export default {
  title: "Bookings",
  descriptionSeller: "Manage all bookings for your activities",
  descriptionHost: "Manage bookings for your activities",
  descriptionAdmin: "View bookings and handshake conversations for this seller",
  adminScopeTitle: "Pick a seller first",
  adminScopeAction: "Go to users",
  adminScopeRequired:
    "Open a seller's detail page and use See bookings to view their bookings.",
  backToPartner: "Back to seller",
  descriptionCustomer: "View your bookings and upload receipts",
  sellerIdMissing: "Seller user ID not found",
  errorLoad: "Error loading bookings",
  viewSelectorLabel: "View",
  viewList: "List",
  viewCalendar: "Calendar",
  calendar: {
    previousWeek: "Previous week",
    nextWeek: "Next week",
    today: "Today",
    todayBadge: "Today",
    openDay: "View {{count}} appointments on {{date}}",
    emptyDay: "No appointments",
    emptyDayDescription: "There are no bookings scheduled for this day.",
    dayStripEmpty: "—",
    dayStripSummary: "{{bookings}} bk · {{covers}} gst",
    daySummaryWithCovers_one: "{{count}} booking · {{covers}} guests total",
    daySummaryWithCovers_other: "{{count}} bookings · {{covers}} guests total",
  },
  cardTitle: "Bookings",
  needsAttention: {
    title: "Needs attention",
    subtitle_one: "{{count}} booking needs your attention",
    subtitle_other: "{{count}} bookings need your attention",
    allClearTitle: "You're all set",
    allClearSubtitle: "Nothing needs attention right now",
    seeAllBookings: "See all bookings",
    showAll: "Show all ({{count}})",
    showAllTitle: "Bookings needing attention",
  },
  stats: {
    tile: {
      confirmation: "To confirm",
      receipts: "Receipts to upload",
      guests: "Guests today",
      completion: "Visits to complete",
    },
  },
  activityFilter: {
    label: "Activity",
    allActivities: "All activities",
    optionWithCount: "{{name}} ({{count}})",
  },
  statusFilter: {
    label: "Status",
    any: "All statuses",
    optionWithCount: "{{name}} ({{count}})",
  },
  actionFilters: {
    label: "Filter by action",
    all: "All actions",
    confirmation: "Awaiting confirmation",
    receipt: "Receipt needed",
    completion: "Visit not completed",
  },
  manageModal: {
    emptyTitle: "Nothing to do",
    emptyDescription: "All bookings are up to date — no actions required.",
    completeConfirmTitle: "Mark visit completed?",
    completeConfirmMessage:
      "This will mark the booking as completed after the visit.",
  },
  partyItems: {
    andMore_one: "+{{count}} more",
    andMore_other: "+{{count}} more",
  },
  list: {
    undatedSection: "No visit date",
  },
  bookingCount_one: "{{count}} booking",
  bookingCount_other: "{{count}} bookings",
  loading: "Loading bookings...",
  emptyTitle: "No bookings yet",
  emptyDescription:
    "Customer bookings will appear here when you receive your first one",
  emptyFilteredTitle: "No bookings match these filters",
  emptyFilteredDescription:
    "Try another status or activity, or clear the filters to see more.",
  unknownActivity: "Unknown Activity",
  guest_one: "{{count}} guest",
  guest_other: "{{count}} guests",
  kioskBookingTitle: "Tablet used for this booking",
  receiptUploadErrorTitle: "Receipt upload error",
  receiptUploadErrorMessage:
    "An error occurred while uploading or analyzing the receipt. Please try again.",
  receiptConfirmErrorTitle: "Receipt confirmation error",
  receiptConfirmErrorMessage:
    "An error occurred while confirming the receipt. Please try again.",
  toastReceiptAlready: "Receipt already registered for this booking.",
  toastPointsAwarded: "Receipt confirmed! +{{points}} loyalty points",
  toastPartnerUploaded: "Receipt uploaded successfully. Total: {{total}}",
  receiptOcrUnreadableTitle: "Receipt not readable",
  receiptOcrUnreadableFallback:
    "Could not read the total from the receipt. Please retake the photo more clearly.",
  receiptManualRequiredTitle: "Manual total required",
  receiptManualCta: "Enter total",
  receiptManualRequiredMessage:
    "Receipt validation attempts are exhausted. Enter the total amount manually.",
  toastPartnerManualAmount: "Manual receipt total saved: {{total}}",
  alertGotIt: "Got it",
  emptyDescriptionCustomer:
    "Your bookings will appear here. Upload receipts from completed visits to earn points.",
  status: {
    CREATED: "Awaiting payment",
    PENDING_HANDSHAKE: "Handshake pending",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
    COMPLETED: "Completed",
    CANCELED: "Canceled",
    ABANDONED: "Expired",
    unknown: "Unknown status",
  },
  partnerStatus: {
    pending: "Pending",
    confirmed: "Confirmed",
  },
  handshake: {
    messageCount_one: "{{count}} message",
    messageCount_other: "{{count}} messages",
    loading: "Loading conversation...",
    loadError: "Could not load handshake conversation",
    notFound: "Handshake conversation not found",
  },
  detail: {
    loading: "Loading booking...",
    loadError: "Could not load this booking",
    notFound: "Booking not found",
    backToList: "Back to bookings",
    orderInfo: "Order details",
    bookingSummary: "Booking",
    requestedVisit: "Requested date",
    bookingType: "Booking type",
    bookingTypes: {
      restaurant: "Restaurant booking",
      service: "Service booking",
    },
    handshakeActions: "Actions",
    chatSectionTitle: "Handshake chat",
    chatChannelCustomer: "{{channel}} — {{name}}",
    chatClosedBadge: "Closed",
    moreActions: "More actions",
    supportHelpAction: "Open support ticket",
    supportTicketSubject: "Booking {{id}}",
    completeSectionTitle: "Complete visit",
    completeSectionDescription:
      "Mark this booking as completed once the visit has taken place.",
    completeSectionAction: "Mark completed",
    receiptSectionTitle: "Upload receipt",
    receiptSectionDescription:
      "Upload a photo of the receipt to complete this booking and calculate the commission.",
    receiptManualSectionTitle: "Enter receipt total",
    receiptManualSectionDescription:
      "Receipt validation attempts are exhausted. Enter the total amount manually to complete this booking.",
    cancelBookingBusy: "Cancelling booking...",
    cancelBookingSuccess: "Booking cancelled",
    cancelBookingError: "Could not cancel this booking",
    cancelBookingPastVisitError:
      "Cannot cancel a booking after the visit date and time has passed",
    cancelBookingConfirmTitle: "Cancel this booking?",
    cancelBookingConfirmMessage:
      "The customer will be refunded when applicable. This cannot be undone.",
        cancelBookingConfirmMessageAdmin:
      "Cancel booking for {{name}} ({{amount}})? The refund starts automatically and cannot be undone.",
cancelBookingConfirmAction: "Cancel booking",
    statusInsight: {
      abandonedTitle: "Payment expired",
      abandonedDescription:
        "The customer did not complete payment in time. This is not a cancellation — the booking was never confirmed.",
    },
    cancellationSource: {
      label: "Cancelled by",
      customer: "Customer",
      partner: "Partner",
      system: "System",
    },
    markComplete: "Mark visit completed",
    markCompleteBusy: "Marking completed...",
    markCompleteSuccess: "Visit marked as completed",
    markCompleteError: "Could not mark this booking as completed",
    chatViaChannel: "Chat via {{channel}}",
    receipt: "Receipt",
    noHandshake: "No handshake conversation for this booking",
    bookingId: "Booking ID",
    services: "Services",
    visitDate: "Visit date",
    visitTime: "Visit time",
    partySize: "Party size",
    customerName: "Customer",
    email: "Email",
    phone: "Phone",
    kiosk: "Tablet / device",
    generatingDevice: "Generating device",
    hostingStructure: "Hosting structure",
    unnamedDevice: "Unnamed device",
    total: "Total",
    amountPaid: "Amount paid",
    listPrice: "List price",
    sellerDiscount: "Partner discount",
    sellerDiscountBadge: "Partner discount",
    sellerDiscountNote:
      "This discount was set by you — your payout is based on the service price after this markdown.",
    servicePrice: "Service price",
    flitripDiscount: "Flitrip discount",
    flitripDiscountBadge: "Flitrip discount",
    flitripDiscountNote:
      "Your payout stays based on the service price — Flitrip covers this discount.",
    pointsDiscount: "Points discount",
    customerPaid: "Customer paid",
    createdAt: "Booked on",
    customerNotes: "Customer notes",
    sellerNotes: "Seller notes",
  },
  adminDetail: {
    tabs: {
      label: "Booking detail sections",
      overview: "Overview",
    },
    ids: {
      title: "Technical references",
      hint: "Copyable IDs for support and developers",
      handshakeSession: "Handshake session",
      externalPayment: "External payment",
    },
    localTime: "({{time}} local time)",
    sections: {
      parties: "Parties involved",
      customer: "Customer",
      booking: "Booking",
      payment: "Payment",
      receipt: "Receipt",
      chat: "Handshake chat",
    },
    timeline: {
      steps: {
        CREATED: "Created",
        PENDING_HANDSHAKE: "Waiting for handshake",
        ACCEPTED: "Accepted",
        COMPLETED: "Completed",
        REJECTED: "Rejected",
        CANCELED: "Canceled",
        ABANDONED: "Expired",
      },
    },
    phone: {
      reveal: "Reveal",
      hide: "Hide",
      confirmTitle: "Reveal customer phone number?",
      confirmMessage:
        "Access to the customer phone number is logged. Only reveal it when you need to contact the customer for support.",
      confirmAction: "Reveal phone",
      revealError: "Could not reveal phone number",
    },
    partner: {
      activity: "Activity",
      name: "Seller",
    },
    payment: {
      none: "No external payment linked to this booking",
      noAccess: "You do not have permission to view external payments",
      models: {
        UPFRONT: "Upfront",
        RECEIPT_BASED: "Receipt-based",
      },
      amount: "Payment amount",
      providerId: "Provider payment ID",
      viewPayment: "View in payments",
      sellerDiscountNote:
        "Partner-funded markdown — partner payout is based on the service price after this discount.",
      flitripDiscountNote:
        "Platform-funded promo — partner payout stays based on the service price; Flitrip covers this discount.",
    },
    economicEvents: {
      title: "Economic events",
      none: "No economic events linked yet",
      noAccess: "You do not have permission to view economic events",
      viewEvent: "View event",
    },
    commissions: {
      activityShort: "Activity",
      houseShort: "House",
    },
    structure: {
      none: "No hosting structure linked",
      host: "Host",
    },
    language: "Language",
    lineItems: {
      qtyUnit: "{{qty}} × {{unit}}",
    },
    receipt: {
      noneYet: "No partner receipt registered yet",
      manualRequired: "Manual receipt amount is required",
      auditTitle: "Receipt upload history",
      auditEmpty: "No receipt uploads yet",
      viewUpload: "View receipt image",
      viewUploadError: "Could not open receipt image",
      manualRegistered: "Manual amount registered",
      amountSource: {
        OCR: "Registered from OCR",
        MANUAL: "Registered manually",
      },
      uploadStatus: {
        uploaded: "Uploaded",
        ocr_succeeded: "OCR succeeded",
        ocr_failed: "OCR failed",
        partner_rejected: "Rejected by partner",
        confirmed: "Confirmed",
      },
    },
    salesAgent: {
      none: "No sales agent assigned to this activity",
      name: "Sales agent",
    },
    chat: {
      readOnlyHint: "Chat is read-only on this page.",
    },
  },
  adminReceiptAdjust: {
    title: "Edit receipt total",
    description:
      "Current registered total: {{current}}. This will reverse the existing fee allocation and create a new one.",
    amountLabel: "New receipt total (EUR)",
    amountPlaceholder: "e.g. 125.50",
    reasonLabel: "Reason (optional)",
    reasonPlaceholder: "Why is this total being corrected?",
    submit: "Save new total",
    action: "Edit receipt total",
    success: "Receipt total updated to {{total}}",
    error: "Could not update receipt total",
    invalidAmount: "Enter a valid amount greater than zero",
    sameAmount: "New total must differ from the current receipt total",
  },
  sellerNotesModal: {
    title: "Seller notes",
    description: "Internal notes for your team. Customers cannot see these.",
    placeholder: "Add notes about this booking...",
    add: "Add notes",
    edit: "Edit notes",
    save: "Save notes",
    saveSuccess: "Seller notes saved",
    saveError: "Could not save seller notes",
    emptyDetail: "No seller notes added yet.",
  },
} as const;
